<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="9" sm="12" class="mt-2">
          <p style="font-size: 17px;color:#2284ab;">Upload Documents</p>
          <p></p>
          <div
            style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"
          >
            <div class="row mb-2">
              <div class="col-md-12">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem; color:red"
                  v-if="currentLan=='eng'"
                >Upload Scanned Copies of Original Documents. Try to avoid Scanned copy of zeroxed documents.</span>
              <br>  <span style="font-size: 0.875rem; color:red">Please note you can upload only jpg, png, jpeg and pdf extention files.</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Applicant Photo * </span>
                <p style="font-size: 0.75rem;color:#2284ab;">Max. file Size 2 MB. Photo size ratio should be 3:2. Only JPG/PNG/JPEG files accepted</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiPhotoPath"
                  @change="onFileChange10"
                  v-if="form.UserLoanDocuments.PhotoPath ==''"
                  accept=".jpg, .png, .gif"
                  size="sm"
                  required
                  v-model="Photo"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.PhotoPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.PhotoPath)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.PhotoPath)" class="img-fluid">
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('PhotoPath', form.UserLoanDocuments.PhotoPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
 <br>
            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan=='mar'">जन्म दिनांक दाखला</span>
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Birth Certificate</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Birth Certificate or School Leaving Certificate *</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDob"
                  @change="onFileChange50"
                  v-if="form.UserLoanDocuments.BirthCertificate==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="dob"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.BirthCertificate!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.BirthCertificate)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.BirthCertificate)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('BirthCertificate', form.UserLoanDocuments.BirthCertificate)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>

             <div class="row">
              <div class="col-md-4">
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Caste Certificate</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Caste Certificate *</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiCCt"
                  @change="onFileChange4"
                  v-if="form.UserLoanDocuments.CastCertificate==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="CastCertificate"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.CastCertificate!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.CastCertificate)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.CastCertificate)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('CastCertificate', form.UserLoanDocuments.CastCertificate)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
             <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Income Certificate *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Income Certificate as issued by Tehsildar’s office</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiICP"
                  @change="onFileChange13"
                  v-if="form.UserLoanDocuments.IncomeCertificatePath  ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="IncomeCertificatePath"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.IncomeCertificatePath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.IncomeCertificatePath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.IncomeCertificatePath)"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('IncomeCertificatePath', form.UserLoanDocuments.IncomeCertificatePath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
             <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Domicile Certificate * </span>
                <p style="font-size: 0.75rem;color:#2284ab;">Domicile Certificate as issued by Tehsildar’s office.</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDomicile"
                  @change="onFileChange110"
                  v-if="form.UserLoanDocuments.DomicileCertificate ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  required
                  v-model="DomicileCertificate"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.DomicileCertificate!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.DomicileCertificate)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.DomicileCertificate)" class="img-fluid">
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('DomicileCertificate', form.UserLoanDocuments.DomicileCertificate)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>

            <br>
 <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan=='mar'">निवासी पुरावा</span>
                <span style="font-size: 0.875rem;" class="ln-eng">Residential Proof *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">
                  Any of the document Recent Electricity Bill/Recent Telephone Bill./ Gas Connection Bill/
                  Passport/Rent Agreement
                </p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiResidentialProof"
                  @change="onFileChange1"
                  v-if="form.UserLoanDocuments.ResidentialProofPath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="residentialproofpath"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.ResidentialProofPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.ResidentialProofPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.ResidentialProofPath)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('ResidentialProofPath', form.UserLoanDocuments.ResidentialProofPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Aadhaar Card * </span>
                <p style="font-size: 0.75rem;color:#2284ab;">Scanned copy of Both Front and Back sides.</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiAddharCard"
                  @change="onFileChange2"
                  v-if="form.UserLoanDocuments.AddharCardPath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="addharcardpath"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.AddharCardPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.AddharCardPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.AddharCardPath)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('AddharCardPath', form.UserLoanDocuments.AddharCardPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
             <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Aadhaar Card(Back) *</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiAddharCardBack"
                  @change="onFileChange21"
                  v-if="form.UserLoanDocuments.AddharCardBackPath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="AdharCardBackPath"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.AddharCardBackPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.AddharCardBackPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.AddharCardBackPath)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('AddharCardBackPath', form.UserLoanDocuments.AddharCardBackPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
             <div class="row">
              <div class="col-md-4">
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Ration Card  *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Scanned copies of First and Last page.</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiRtn"
                  @change="onFileChange49"
                  v-if="form.UserLoanDocuments.RationCardPath==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="dob"
                  class="mt-3"
                  required
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.RationCardPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.RationCardPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.RationCardPath)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('RationCardPath', form.UserLoanDocuments.RationCardPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br/>
            <!--RationCard-->

            <!--RationCard-->
            <div class="row">
              <div class="col-md-4">
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Ration Card Last Page *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Scanned copies of Last page.</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiRtnlst"
                  @change="onFileChangeRationLast"
                  v-if="form.UserLoanDocuments.RationCardLastPath==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="rtnlst"
                  class="mt-3"
                  required
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.RationCardLastPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.RationCardLastPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.RationCardLastPath)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('RationCardLastPath', form.UserLoanDocuments.RationCardLastPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br/>
            <!--RationCard-->
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Pan Card * </span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiPAN"
                  @change="onFileChange101"
                  v-if="form.UserLoanDocuments.PancardPath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  required
                  v-model="PAN"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.PancardPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.PancardPath)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.PancardPath)" class="img-fluid">
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('PancardPath', form.UserLoanDocuments.PancardPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>

            <br>
            
           


            <div class="row" style="display:none">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Applicant Signature *</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiSign"
                  @change="onFileChange12"
                  v-if="form.UserLoanDocuments.SignaturePath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="Signature"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.SignaturePath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.SignaturePath)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.SignaturePath)" class="img-fluid">
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('SignaturePath', form.UserLoanDocuments.SignaturePath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
           

            <div class="row" style="display:none">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Income Tax Application *</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiITApp"
                  @change="onFileChange3"
                  v-if="form.UserLoanDocuments.IncomeTaxApplication ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="incometaxapplication"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.IncomeTaxApplication!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.IncomeTaxApplication)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.IncomeTaxApplication)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('IncomeTaxApplication', form.UserLoanDocuments.IncomeTaxApplication)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <!-- <br> -->
           
            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan=='mar'">जन्म दिनांक दाखला</span>
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Birth Certificate</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Birth Certificate or School Leaving Certificate *</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDob"
                  @change="onFileChange50"
                  v-if="form.UserLoanDocuments.BirthCertificate==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="dob"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.BirthCertificate!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.BirthCertificate)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.BirthCertificate)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('BirthCertificate', form.UserLoanDocuments.BirthCertificate)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>

            <div class="row">
              <div class="col-md-4">
                <span
                  style="font-size: 0.875rem;"
                  class="ln-eng"
                >Bank Account Proof *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Bank Passbook or cancelled Cheque with Account Number and IFSC.</p>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiBank"
                  @change="onFileChange57"
                  v-if="form.UserLoanDocuments.BankAccount==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="BankAccount"
                  class="mt-3"
                  plain required
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.BankAccount!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.BankAccount)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.BankAccount)"
                    alt="X"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('BankAccount', form.UserLoanDocuments.BankAccount)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>

            <!--RationCard-->
          

            <!--Other Document-->
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Other Document</span>

                <b-form-input
                  id="inpBranch"
                  type="text"
                  v-model="form.UserLoanDocuments.OtherName"
                  size="sm"
                  placeholder="Other Documets"
                ></b-form-input>

              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiODs"
                  @change="onFileChange5"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  v-if="form.UserLoanDocuments.OtherDocument==''"
                  v-model="OtherDocument"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.OtherDocument!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.OtherDocument)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.OtherDocument)"
                    width="100px"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('OtherDocument', form.UserLoanDocuments.OtherDocument)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
            <!--Other Document-->

            <!--Other Document2-->
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Other Document 2</span>
                <b-form-input
                  id="inpBranch"
                  type="text"
                  v-model="form.UserLoanDocuments.Other2Name"
                  size="sm"
                  placeholder="Enter Document Name"
                ></b-form-input>

              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiOD2"
                  @change="onFileChange52"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  v-if="form.UserLoanDocuments.Other2==''"
                  v-model="OtherDocument2"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other2!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other2)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.Other2)"
                    width="100px"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other2', form.UserLoanDocuments.Other2)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
            <!--Other Document2-->

            <!--Other Document3-->
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Other Document 3</span>
                <b-form-input
                  id="inpBranch"
                  type="text"
                  v-model="form.UserLoanDocuments.Other3Name"
                  size="sm"
                  placeholder="Enter Document Name"
                ></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiOD3"
                  @change="onFileChange53"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  v-if="form.UserLoanDocuments.Other3==''"
                  v-model="OtherDocument3"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other3!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other3)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.Other3)"
                    width="100px"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other3', form.UserLoanDocuments.Other3)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
            <!--Other Document3-->

            <!--Other Document4-->
            <div class="row">
              <div class="col-md-4">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem;"
                  v-if="currentLan=='eng'"
                >Other Document 4</span>
                <b-form-input
                  id="inpBranch"
                  type="text"
                  v-model="form.UserLoanDocuments.Other4Name"
                  size="sm"
                  placeholder="Enter Document Name"
                ></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiOD4"
                  @change="onFileChange54"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  v-if="form.UserLoanDocuments.Other4==''"
                  v-model="OtherDocument4"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other4!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other4)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.Other4)"
                    width="100px"
                    class="img-fluid"
                  >
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other4', form.UserLoanDocuments.Other4)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br>
            <!--Other Document4-->
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!getUser.LockProfile">
        <b-col md="5" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";

import lambda from "@/apis/lambda";
import Spinner from "vue-simple-spinner";
import store from '../../store'
const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"]
  .map(function(x) {
    return "." + x;
  })
  .join(",");
export default {
  components: { Spinner },
  data() {
    return {
      userId: "",
      imgPath: "",
      currentLan: "eng",
      show: true,
      Photo: null,
      Signature: null,
      Aadhaar: null,
      AdharCardBackPath: null,
      rationCard: null,
      rtnlst:null,
      IncomeCertificate: null,
      dob: null,
      Caste: null,
      Degree: null,
      Experience: null,
      RecoLetter: null,
      CourtOrder: null,
      DeceasedID: null,
      LegalHireNOC: null,
      FinalDuesLetter: null,
      OtherDocument: null,
      OtherDocument2: null,
      OtherDocument3: null,
      OtherDocument4: null,
      CastCertificate: null,
      residentialproofpath: null,
      SignaturePath: null,
      incometaxapplication: null,
      addharcardpath: null,
      showDismissibleAlert: false,
      IncomeCertificatePath: null,
      DomicileCertificate: null,
      BankAccount: null,
      PAN: null,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false,
      docObj: {},
      docTbl: [],
      modalInfo: "",
      selecteObj: {
        Document: "",
        Path: ""
      },
      fields: [
        { key: "Document", label: "Document" },
        { key: "Path", label: "File" },
        { key: "action", label: "View" }
      ],
      form: {
        UserLoadDocumentUpload: {
          ResidentialProofStatus: false,
          AddharCardStatus: false,
          AddharCardBackStatus: false,
          IncomeTaxApplicationStatus: false,
          CastCertificateStatus: false,
          OtherDocumentStatus: false,
          PhotoPathStatus: false,
          DomicileCertificate: false,
          SignaturePathStatus: false,
          IncomeCertificatePathStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false,
          DegreeCertificateStatus: false,
          CasteCertificateStatus: false,
          DOBCertificateStatus: false,
          RationCardStatus: false,
          AdharCardStatus: false,
          ApplicantSignatureStatus: false,
          ApplicantPhotoStatus: false,
          RecoLetterStatus: false,
          CourtOrderStatus: false,
          DeceasedIDStatus: false,
          LegalHireNOCStatus: false,
          FinalDuesLetterStatus: false,
          PoliceVerificationStatus: false,
          BirthCertificateStatus: false,
          PancardStatus: false
        },
        UserLoanDocuments: {
          ResidentialProofPath: "",
          AddharCardPath: "",
          IncomeTaxApplication: "",
          CastCertificate: "",
          OtherDocument: "",
          PhotoPath: "",
          SignaturePath: "",
          IncomeCertificatePath: "",
          AdharCardPath: "",
          AdharCardBackPath: "",
          PancardPath: "",
          DomicileCertificate: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: "",
          PoliceVerification: "",
          BankAccount: "",
          Other2: "",
          Other3: "",
          Other4: "",
          OtherName: "",
          Other2Name: "",
          Other3Name: "",
          Other4Name: ""
        },
        LoanApplication: [
          {
            LoanType: 1,
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ],
        LoginID: ""
      }
    };
  },
  computed: {
    getUserCat() {
      let x = this.$store.getters.getUserData;
      //console.log("X", x);
      if (x.UserReligionCaste) {
        if (
          x.UserReligionCaste.CategoryID ==
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b"
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    getUser() {
      let x = this.$store.getters.getUserData;

      if (x) {
        return x;
      } else {
        return { LockProfile: false };
      }
    }
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    showImages(item, index, target) {
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      let link =
        "https://aws.msobcfdc.in/S3BucketApril/" +
        userid +
        "/" +
        item.Path;
      // this.imgPath = link;
      // this.$refs.myModalRef.show()
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },

    onFileChange57(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiBank.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"BankAccount_." + extn;
      var filepath = "BankAccount_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.BankAccount = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onFileChange1(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiResidentialProof.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"ResidentialProof_." + extn;
      var filepath = "ResidentialProof_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.ResidentialProofPath = filepath;
            this.form.UserLoadDocumentUpload.ResidentialProofStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onFileChange2(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiAddharCard.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath = userid+"!!~~!!"+"AddharCard_." + extn;
      var filepath = "AddharCard_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.AddharCardPath = filepath;
            this.form.UserLoadDocumentUpload.AddharCardStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiAddharCard.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiAddharCard.reset();
          this.isLoading = false;
        });
    },
    onFileChange21(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiAddharCardBack.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"AddharCardBack_." + extn;
      var filepath = "AddharCardBack_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.AddharCardBackPath = filepath;
            this.form.UserLoadDocumentUpload.AddharCardBackStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiAddharCardBack.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiAddharCardBack.reset();
          this.isLoading = false;
        });
    },

    onFileChange3(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiITApp.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"IncomeTaxApplication_." + extn;
      var filepath = "IncomeTaxApplication_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.IncomeTaxApplication = filepath;
            this.form.UserLoadDocumentUpload.IncomeTaxApplicationStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiITApp.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiITApp.reset();
          this.isLoading = false;
        });
    },

    onFileChange4(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiCCt.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"CastCertificate_." + extn;
      var filepath = "CastCertificate_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.CastCertificate = filepath;
            this.form.UserLoadDocumentUpload.CastCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiCCt.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiCCt.reset();
          this.isLoading = false;
        });
    },
    onFileChange50(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDob.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"BirthCertificate_." + extn;
      var filepath = "BirthCertificate_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.BirthCertificate = filepath;
            this.form.UserLoadDocumentUpload.BirthCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiODs.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiODs.reset();
          this.isLoading = false;
        });
    },

    onFileChange5(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiODs.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"OtherDocument_." + extn;
      var filepath = "OtherDocument_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.OtherDocument = filepath;
            this.form.UserLoadDocumentUpload.OtherDocumentStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiODs.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiODs.reset();
          this.isLoading = false;
        });
    },

    onFileChange52(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiOD2.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"OtherDocument2_." + extn;
      var filepath = "OtherDocument2_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.Other2 = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiOD3.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiOD2.reset();
          this.isLoading = false;
        });
    },

    onFileChange53(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiOD3.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"OtherDocument3_." + extn;
      var filepath = "OtherDocument3_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.Other3 = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiOD3.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiOD3.reset();
          this.isLoading = false;
        });
    },

    onFileChange54(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiOD4.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"OtherDocument4_." + extn;
      var filepath = "OtherDocument4_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.Other4 = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiOD4.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiOD4.reset();
          this.isLoading = false;
        });
    },

    onFileChange49(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiRtn.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"RationCard_." + extn;
      var filepath = "RationCard_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.RationCardPath = filepath;
            this.form.UserLoadDocumentUpload.RationCardStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiReco.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiReco.reset();
          this.isLoading = false;
        });
    },

    onFileChangeRationLast(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiRtnlst.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"RationCardLastPage_." + extn;
      var filepath = "RationCardLastPage_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.RationCardLastPath = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiReco.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiReco.reset();
          this.isLoading = false;
        });
    },

    onFileChange9(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiReco.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"RecommendationLetter_." + extn;
      var filepath = "RecommendationLetter_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UserLoanDocuments.RecommendationLetter = filepath;
            this.form.UserLoadDocumentUpload.RecoLetterStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiReco.reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiReco.reset();
          this.isLoading = false;
        });
    },

    onFileChange10(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhotoPath.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"PhotoPath_." + extn;
      var filepath = "PhotoPath_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.PhotoPath = filepath;
            this.form.UserLoadDocumentUpload.PhotoPathStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onFileChange101(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPAN.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"PancardPath_." + extn;
      var filepath = "PancardPath_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.PancardPath = filepath;
            this.form.UserLoadDocumentUpload.PancardStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onFileChange110(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDomicile.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"Domicile_." + extn;
      var filepath = "Domicile_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.DomicileCertificate = filepath;
            this.form.UserLoadDocumentUpload.DomicileCertificate = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onFileChange12(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiSign.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"SignPath_." + extn;
      var filepath = "SignPath_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.SignaturePath = filepath;
            this.form.UserLoadDocumentUpload.SignaturePathStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onFileChange13(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiICP.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var _filepath=userid+"!!~~!!"+"IncomeCetificate_." + extn;
      var filepath = "IncomeCetificate_." + extn;
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];
       
    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserLoanDocuments.IncomeCertificatePath = filepath;
            this.form.UserLoadDocumentUpload.IncomeCertificatePathStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      //this.form.LoanApplication[0].LoanType = this.$store.getters.getScheme.LoanType;
      //this.form.LoanApplication[0].UserID = userinfo.UserId;
      if (
        (this.form.UserLoanDocuments.OtherDocument != "" && this.form.UserLoanDocuments.OtherName=="") ||
        (this.form.UserLoanDocuments.Other2 != "" && this.form.UserLoanDocuments.Other2Name == "") ||
        (this.form.UserLoanDocuments.Other3 != "" && this.form.UserLoanDocuments.Other3Name == "") ||
        (this.form.UserLoanDocuments.Other4 != "" && this.form.UserLoanDocuments.Other4Name == "")
      ) {
        this.showDismissibleAlert = true;
        this.alertText = "Please add Name of the Other Documents added";
        this.variant = "warning";
      }
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.loadLoanImageList();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.$refs.fiResidentialProof.reset();
      this.$refs.fiAddharCard.reset();
      this.$refs.fiAddharCardBack.reset();
      this.$refs.fiITApp.reset();
      this.$refs.fiCCt.reset();
      this.$refs.fiODs.reset();
      this.$refs.fiPV.reset();
      this.$refs.fiReco.reset();
      this.$refs.fiPhotoPath.reset();
      this.$refs.fiSign.reset();
      this.$refs.fiICP.reset();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },

    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            if (this.docTbl.length > 0) {
              this.loadLoanImageList();
            }
            switch (this.selecteObj.Document) {
              case "ResidentialProofPath":
                this.$refs.fiResidentialProof.reset();
                break;
              case "AddharCardPath":
                this.$refs.fiAddharCard.reset();
                break;
              case "AddharCardBackPath":
                this.$refs.fiAddharCardBack.reset();
                break;
              case "IncomeTaxApplication":
                this.$refs.fiITApp.reset();
                break;
              case "CastCertificate":
                this.$refs.fiCCt.reset();
                break;
              case "OtherDocument":
                this.$refs.fiODs.reset();
                break;
              case "Other2":
                this.$refs.fiODs.reset();
                break;
              case "Other3":
                this.$refs.fiODs.reset();
                break;
              case "Other4":
                this.$refs.fiODs.reset();
                break;
              case "PhotoPath":
                this.$refs.fiPhotoPath.reset();
                break;
              case "SignaturePath":
                this.$refs.fisign.reset();
                break;
              case "RationCardPath":
                this.$refs.fiRtn.reset();
                break;
              case "RationCardLastPath":
                this.$refs.fiRtnlst.reset();
                break;
              case "IncomeCertificatePath":
                this.$refs.fiICP.reset();
                break;

              case "BankAccount":
                this.$refs.fiBank.reset();
                break;
            }
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
    loadLoanImageList() {
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;

      var userid = userinfo.UserId;
      //   var filename =   this.Photo.name;
      let promise = apis.readLoanDocumentPath(userid);
      this.docTbl = [];
      promise
        .then(response => {
          if (response.status == 200) {
            this.form.UserLoanDocuments = response.body;
            // console.log('Documents', response.body);
            this.docObj = response.body;
            for (var key in this.docObj) {
              if (this.docObj.hasOwnProperty(key)) {
                if (this.docObj[key]) {
                  if (this.docObj[key] != "" && this.docObj[key] != null) {
                    let link =
                      "https://aws.msobcfdc.in/S3BucketApril/" +
                      userid +
                      "/" +
                      this.docObj[key];

                    this.docTbl.push({
                      Document: key,
                      Path: this.docObj[key],
                      link: link
                    });
                  }
                }
                //console.log(key + " -> " + this.docObj[key]);
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;

    if (this.$store.getters.isLoggedIn) {
      this.loadLoanImageList();
    }
  }
};
</script>

<style scoped>
img {
  width: 50px;
  border-radius: 2px;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);
  transition: width 1s;
}
</style>




// WEBPACK FOOTER //
// src/components/RegistrationLoan/FormUploads.vue